import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Button, Input, theme } from 'antd';
import { IThemeProps, IToken } from 'store/ducks/globalTypes';
import CustomTextarea from 'components/CustomTextarea';

const { useToken } = theme;
const { TextArea } = Input;

export const ColumnTextBox = styled(CustomTextarea)`
  margin-top: -15px;
`;

export const ContentWrapper = styled('div')`
  width: 100%;
  padding: 10px;

  .ant-table-wrapper .ant-table {
    .ant-table-filter-column {
      flex-direction: row-reverse;

      .ant-dropdown-trigger {
        margin-inline: 0 5px;
        color: white;
      }
    }
    .ant-table-content {
      border-radius: 10px;
    }
    .ant-table-thead tr .ant-table-cell {
      white-space: nowrap;
      padding: 0px 12px !important;
      height: 0px;
      line-height: 0px;
    }

    .ant-table-thead > tr:nth-child(2) > th {
      padding: 0;
      height: 0;
      line-height: 0;
      border: 0;
    }

    .ant-table-thead > tr:nth-child(2) > th::before {
      display: none;
      content: none;
    }

    .ant-table-tbody .ant-table-cell-fix-left {
      background-color: inherit !important;
    }
  }

  .has-row-tooltip[data-tooltip]::before {
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .has-row-tooltip:hover::before {
    opacity: 1;
  }

  .disabled-row {
    opacity: 0.6;
  }
`;

export const RiskContentWrapper = styled('div')`
  width: 100%;
  padding: 5px;

  .ant-table-wrapper .ant-table {
    .ant-table-filter-column {
      flex-direction: row-reverse;

      .ant-dropdown-trigger {
        margin-inline: 0 0px;
        color: white;
      }
    }
    .ant-table-content {
      border-radius: 10px;
    }
    .ant-table-thead tr .ant-table-cell {
      white-space: nowrap;
      padding: 0px 12px !important;
      height: 48px;
      line-height: 48px;
      vertical-align: top;
      padding-top: 3px !important;
    }

    .ant-table-tbody .ant-table-cell-fix-left {
      background-color: inherit !important;
    }
  }

  .has-row-tooltip[data-tooltip]::before {
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .has-row-tooltip:hover::before {
    opacity: 1;
  }

  .disabled-row {
    opacity: 0.6;
  }
`;

const GlobalTooltipStylesBase = createGlobalStyle<IToken>`
  .ant-tooltip .ant-tooltip-inner {
    background-color: ${(props) =>
      props.token?.colorText || '#000000'} !important;
    color: ${(props) => props.token?.colorBgContainer || '#ffffff'} !important;
    border: none !important;
    box-shadow: none !important;
    font-size: 12px !important;
    max-width: 200px !important;
  }

  .ant-tooltip .ant-tooltip-arrow {
    display: none !important;
  }
  
  .ant-checkbox-inner {
    border: 2px solid ${(props) =>
      props.token?.colorText || '#000000'} !important;
    background-color: ${(props) =>
      props.token?.colorBgContainer || '#ffffff'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
    
  }
  
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) =>
      props.token?.colorBgContainer || '#ffffff'} !important;
    border-color: ${(props) => props.token?.colorText || '#000000'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }
  
  .ant-checkbox-checked .ant-checkbox-inner::after {
    border: 3px solid ${(props) =>
      props.token?.colorText || '#000000'} !important;
    border-top: 0 !important;
    border-left: 0 !important;
    opacity: 1 !important;
    display: block !important;
    width: 5px !important;
    height: 10px !important;
    transform: rotate(45deg) !important;
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    margin-top: -6px !important;
    margin-left: -2px !important;
  }
  
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${(props) => props.token?.colorText || '#000000'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }
  
  .ant-checkbox-checked:hover .ant-checkbox-inner {
    border-color: ${(props) => props.token?.colorText || '#000000'} !important;
    box-shadow: inset 0 0 0 1px ${(props) =>
      props.token?.colorText || '#000000'} !important;
  }

  .ant-table-filter-dropdown .ant-dropdown-menu-item,
  .ant-table-filter-dropdown .ant-dropdown-menu-item span {
    color: ${(props) => props.token?.colorText || '#000000'} !important;
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link {
    color: ${(props) => props.token?.colorPrimary || '#1677ff'};
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link span {
    color: ${(props) => props.token?.colorPrimary || '#1677ff'};
  }

  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link:disabled,
  .ant-table-filter-dropdown .ant-table-filter-dropdown-btns .ant-btn-link:disabled span {
    color: ${(props) => props.token?.colorText || '#000000'};
  }
`;

export const GlobalTooltipStyles: React.FC = () => {
  const { token } = useToken();
  return <GlobalTooltipStylesBase token={token} />;
};

export const StyledButton = styled(Button)`
  border: unset;
  margin-bottom: 5px;
  min-width: 24px;
  border-radius: 50%;
  background-color: rgba(0, 54, 84, 0.5);
  padding: 0;
  width: 24px !important;
  height: 24px;
  align-self: flex-end;
  margin-left: 6px;
`;

export const StyledButtonSection = styled('div')<IToken>`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => `${props.token.marginSM}px`};
`;

export const ApplyButton = styled(Button)<IThemeProps & Partial<IToken>>`
  border-radius: 6px;
  font-weight: 500;
  background-color: ${(props) =>
    props.type === 'primary'
      ? props.token?.colorError || '#ff7875'
      : 'inherit'};
  border-color: ${(props) =>
    props.type === 'primary'
      ? props.token?.colorError || '#ff7875'
      : 'inherit'};
  color: ${(props) =>
    props.type === 'primary' ? '#fff !important' : 'inherit'};

  &:hover {
    background-color: ${(props) =>
      props.type === 'primary'
        ? props.token?.colorErrorHover || '#ff9c99'
        : props.token?.colorPrimaryBgHover || 'inherit'} !important;
    border-color: ${(props) =>
      props.type === 'primary'
        ? props.token?.colorErrorHover || '#ff9c99'
        : props.token?.colorPrimaryBgHover || 'inherit'} !important;
    color: #fff !important;
  }
`;

export const AddRowArea = styled('div')`
  width: 100%;
  text-align: center;
  margin-top: 10px;
`;

export const ErrorDisplayContainer = styled('div')`
  background-color: #ffebee;
  border: 1px solid #f44336;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
  max-height: 200px;
  overflow: auto;
`;

export const ErrorTitle = styled('h4')`
  color: #d32f2f;
  margin: 0 0 8px 0;
`;

export const ErrorContent = styled('pre')`
  margin: 0;
  font-size: 12px;
  white-space: pre-wrap;
`;

export const ErrorButton = styled(Button)`
  margin-top: 8px;
`;

export const ButtonContainer = styled('div')`
  margin-bottom: 16px;
`;

export const TooltipRisk = styled.div`
  color: black !important;
`;

export const ResizableTextArea = styled(TextArea)<Partial<IToken>>`
  resize: both;
  min-width: 150px;
  min-height: 32px;
  font-size: 12px;
  color: #000000 !important;
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 4px 11px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: ${(props) => props.token?.colorPrimary || '#4096ff'};
  }

  &:focus {
    border-color: ${(props) => props.token?.colorPrimary || '#4096ff'};
    box-shadow: 0 0 0 2px
      ${(props) => props.token?.colorPrimaryBg || 'rgba(64, 150, 255, 0.1)'};
    outline: 0;
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.token?.colorBgContainer || '#f1f1f1'};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.token?.colorBorder || '#c1c1c1'};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.token?.colorBorderSecondary || '#a8a8a8'};
  }
`;

export const tooltipTR = styled('tr')`
  opacity: 0.5;
  cursor: not-allowed;
`;

export const Asterisx = styled('b')`
  color: red;
  font-size: 25px;
  margin-top: 7px;
  font-weight: 500;
`;

export const ProcessType = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ControlContentWrapper = styled('div')`
  width: 100%;
  padding: 5px;

  .ant-table-wrapper .ant-table {
    .ant-table-filter-column {
      flex-direction: row-reverse;

      .ant-dropdown-trigger {
        margin-inline: 0 0px;
        color: white;
      }
    }
    .ant-table-content {
      border-radius: 10px;
    }
    .ant-table-thead tr .ant-table-cell {
      white-space: normal;
      padding: 0px 12px !important;
      height: auto;
      line-height: normal;
      vertical-align: middle;
    }

    .ant-table-thead > tr:nth-child(2) > th {
      padding: 0;
      height: 0;
      line-height: 0;
      border: 0;
    }

    .ant-table-thead > tr:nth-child(2) > th::before {
      display: none;
      content: none;
    }

    .ant-table-tbody .ant-table-cell-fix-left {
      background-color: inherit !important;
    }
  }

  .has-row-tooltip[data-tooltip]::before {
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .has-row-tooltip:hover::before {
    opacity: 1;
  }

  .disabled-row {
    opacity: 0.6;
  }
`;

export const DesignEffectivenessWrapper = styled('div')`
  width: 100%;
  padding: 5px;

  .ant-table-wrapper .ant-table {
    .ant-table-filter-column {
      flex-direction: row-reverse;

      .ant-dropdown-trigger {
        margin-inline: 0 0px;
        color: white;
      }
    }
    .ant-table-content {
      border-radius: 10px;
    }
    .ant-table-thead tr .ant-table-cell {
      white-space: nowrap;
      padding: 0px 12px !important;
      height: 45px;
      line-height: 45px;
    }

    .ant-table-tbody .ant-table-cell-fix-left {
      background-color: inherit !important;
    }
  }

  .has-row-tooltip[data-tooltip]::before {
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .has-row-tooltip:hover::before {
    opacity: 1;
  }

  .disabled-row {
    opacity: 0.6;
  }
`;

export const OperationalEffectivenessWrapper = styled('div')`
  width: 100%;
  padding: 5px;

  .ant-table-wrapper .ant-table {
    .ant-table-filter-column {
      flex-direction: row-reverse;

      .ant-dropdown-trigger {
        margin-inline: 0 0px;
        color: white;
      }
    }
    .ant-table-content {
      border-radius: 10px;
    }
    .ant-table-thead tr .ant-table-cell {
      white-space: nowrap;
      padding: 0px 12px !important;
      height: 45px;
      line-height: 45px;
    }

    .ant-table-tbody .ant-table-cell-fix-left {
      background-color: inherit !important;
    }
  }

  .has-row-tooltip[data-tooltip]::before {
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .has-row-tooltip:hover::before {
    opacity: 1;
  }

  .disabled-row {
    opacity: 0.6;
  }
`;

export const CopyIcon = styled(Button)`
  border: none;
  &:hover {
    color: white !important;
  }
  span {
    &:hover {
      color: white;
    }
  }
`;

export const KeyControlText = styled.span`
  display: block;
  margin-top: 10px;
`;

export const DisabledTooltipDiv = styled('div')`
  opacity: 0.5;
  cursor: not-allowed;
`;

export const DatePickerOperational = styled('div')`
  width: 180px;
  color: black;
`;

export const DatePickerNext = styled('div')`
  width: 180px;
`;

export const KeyControlInput = styled(Input)<Partial<IToken>>`
  width: 80px;
  margin-top: 5px;
  color: ${(props) => props.token?.colorText || '#000000'} !important;

  &.ant-input-disabled {
    color: ${(props) => props.token?.colorText || '#000000'} !important;
  }
`;
